import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("dt", { class: "product_tit" }, "이용안내", -1)
const _hoisted_2 = { class: "product_txt" }
const _hoisted_3 = /*#__PURE__*/_createVNode("dt", { class: "product_tit" }, "이용 가능 매장", -1)
const _hoisted_4 = { class: "product_txt" }
const _hoisted_5 = /*#__PURE__*/_createVNode("dt", { class: "product_tit" }, "이용 불가 매장", -1)
const _hoisted_6 = { class: "product_txt" }
const _hoisted_7 = /*#__PURE__*/_createVNode("dt", { class: "product_tit" }, "유의사항", -1)
const _hoisted_8 = { class: "product_txt" }
const _hoisted_9 = { class: "lst_noti" }
const _hoisted_10 = /*#__PURE__*/_createVNode("dt", { class: "product_tit" }, "문의처", -1)
const _hoisted_11 = { class: "product_txt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("dl", {
    class: {product_info_area: _ctx.isForTicketDetail}
  }, [
    _hoisted_1,
    _createVNode("dd", _hoisted_2, _toDisplayString(_ctx.product.informationUseText), 1),
    _hoisted_3,
    _createVNode("dd", _hoisted_4, _toDisplayString(_ctx.product.usableMerchantText), 1),
    _hoisted_5,
    _createVNode("dd", _hoisted_6, _toDisplayString(_ctx.product.unusableMerchantText), 1),
    _hoisted_7,
    _createVNode("dd", _hoisted_8, [
      _createVNode("ul", _hoisted_9, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cautionList, (caution, index) => {
          return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(caution), 1))
        }), 128))
      ])
    ]),
    _hoisted_10,
    _createVNode("dd", _hoisted_11, [
      _createTextVNode(_toDisplayString(_ctx.product.contactUs) + " ", 1),
      _createVNode("a", {
        href: _ctx.contactLink,
        class: "tel"
      }, _toDisplayString(_ctx.product.contactUsTel), 9, ["href"])
    ])
  ], 2))
}